/*
  786 Motion Plus - sliders
  -------------------------
  Drag-to-scroll with a flick that carries on and eases out, plus press
  feedback on arrows. Only containers that genuinely scroll sideways are
  touched, so transform-driven carousels are left alone.
*/
(function () {
  'use strict';

  var html = document.documentElement;
  if (html.classList.contains('motion-off')) return;
  var G = window.gsap;
  if (!G) return;

  function q(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var TRACKS = ['.ptb786-track', '.s786-carousel__track', '.s786-pdp__thumbs',
    '.s786-bundle__grid', '.j-chips', '.s786-coll__tabs', '.ptb786-tabs-window'].join(',');

  function scrollable(el) {
    var ox = getComputedStyle(el).overflowX;
    return (ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth + 4;
  }

  function glide(el, velocity) {
    var o = { v: el.scrollLeft };
    var target = el.scrollLeft - velocity * 180;
    target = Math.max(0, Math.min(target, el.scrollWidth - el.clientWidth));
    G.to(o, {
      v: target, duration: 1.1, ease: 'power3.out', overwrite: true,
      onUpdate: function () { el.scrollLeft = o.v; }
    });
  }

  function drag(el) {
    if (el.dataset.mpDrag) return;
    el.dataset.mpDrag = '1';
    el.classList.add('mp-drag');

    var down = false, moved = false, startX = 0, startLeft = 0, lastX = 0, lastT = 0, vel = 0;

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; moved = false; vel = 0;
      startX = lastX = e.clientX;
      startLeft = el.scrollLeft;
      lastT = performance.now();
      G.killTweensOf(el);
    });

    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 6) {
        moved = true;
        el.classList.add('is-dragging');
        try { el.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (!moved) return;
      e.preventDefault();
      el.scrollLeft = startLeft - dx;
      var now = performance.now();
      var dt = now - lastT;
      if (dt > 0) vel = (e.clientX - lastX) / dt;
      lastX = e.clientX; lastT = now;
    });

    function release(e) {
      if (!down) return;
      down = false;
      if (!moved) return;
      el.classList.remove('is-dragging');
      try { el.releasePointerCapture(e.pointerId); } catch (err) {}
      if (Math.abs(vel) > 0.15) glide(el, vel);
      setTimeout(function () { moved = false; }, 0);
    }

    el.addEventListener('pointerup', release);
    el.addEventListener('pointercancel', release);
    el.addEventListener('pointerleave', release);

    /* A drag must not fire the link underneath. */
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  function arrows(root) {
    q('.ptb786-arrow, .s786-circle, .s786-hero2__arrow, .n786-arrow', root).forEach(function (b) {
      if (b.dataset.mpArrow) return;
      b.dataset.mpArrow = '1';
      b.addEventListener('click', function () {
        G.fromTo(b, { scale: 0.88 }, { scale: 1, duration: 0.5, ease: 'elastic.out(1, 0.6)' });
      });
    });
  }

  function boot(root) {
    root = root || document;
    try {
      q(TRACKS, root).forEach(function (el) { if (scrollable(el)) drag(el); });
      arrows(root);
    } catch (e) { if (window.console) console.warn('[786 slider]', e); }
  }

  window.MotionSlider = { boot: boot };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else { boot(document); }
  window.addEventListener('load', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
